import { useMemo, useCallback } from 'react';
import { Debounced } from './debounced';
export function useDebounce(callback, ...rest) {
    const [debounced, dependencies] = useMemo(() => {
        if (rest.length === 1) {
            const debounced = new Debounced(callback);
            const dependencies = rest[0];
            return [debounced, dependencies];
        }
        else {
            const debounced = new Debounced(callback, rest[0]);
            const dependencies = rest[1];
            return [debounced, dependencies];
        }
    }, [callback, rest]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    return useCallback(debounced.call, dependencies);
}
